import type { ReactNode } from 'react';
import { Nav } from './Nav';
import { Footer } from './Footer';

interface PageShellProps {
  children: ReactNode;
}

export function PageShell({ children }: PageShellProps) {
  return (
    <>
      <Nav />
      <main className="page-pad">{children}</main>
      <Footer />
    </>
  );
}
